import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {TEMPLATES_STATE_NAME, ReportTemplatesState} from "./templates";
import {selectSavedReportByID} from '../savedReports/savedReports.selectors';
import {ReportTemplate} from '../../interfaces/ad-reports';
import {Serializer} from '../../interfaces/serializer';

export const selectTemplatesState = createFeatureSelector<ReportTemplatesState>(TEMPLATES_STATE_NAME);

export const selectTemplates: MemoizedSelector<object, ReportTemplatesState> = createSelector(
  selectTemplatesState,
  (state: ReportTemplatesState): ReportTemplatesState => state
);

export const selectTemplatesCatLists = createSelector(
  selectTemplatesState,
  (state: ReportTemplatesState) => state.cat_lists
);

export const selectTemplatesLoading: MemoizedSelector<object, boolean> = createSelector(
  selectTemplatesState,
  (state: ReportTemplatesState): boolean => state.loading
);

export const selectTemplatesLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectTemplatesState,
  (state: ReportTemplatesState): boolean => state.loaded
);

export const selectCheckTemplatesLoading: MemoizedSelector<object, boolean> = createSelector(
  selectTemplatesState,
  (state: ReportTemplatesState): boolean => state.checkLoading
);

export const selectTemplateByID: (ID: number | string) => MemoizedSelector<Object, Serializer<ReportTemplate>, (state: ReportTemplatesState) => Serializer<ReportTemplate>> = (ID: number | string) => createSelector(
  selectTemplatesState,
  (state: ReportTemplatesState): Serializer<ReportTemplate> => state.templates.data.find((template: Serializer<ReportTemplate>): boolean => template.id == ID)
)
